import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState, useEffect, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import CleaningTraceabilityItemApi from "../../common/Apis/CleaningTraceabilityItemApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const EditCleaningTraceabilityItem = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const [Traceability, setTraceability] = useState();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const getTraceabilitys = useCallback(() => {
    CleaningTraceabilityItemApi.SingleTraceabilityItemApi(id)
      .then((response) => {
        setTraceability(response.payload);
        form.setFieldsValue({
          institutionId: response?.payload?.institutionDTO?.id,
          traceabilityName: response?.payload?.traceabilityName,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);


  useEffect(() => {
    PageLoading();
    getTraceabilitys();
  }, [getTraceabilitys, PageLoading]);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      traceabilityName: data.traceabilityName,
      institutionDTO: {
        id: data.institutionId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    CleaningTraceabilityItemApi.PutTraceabilityItemApi(Traceability?.id, formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/cleaning-traceability/cleaning-list");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="traceabilityName"
                    label="Cleaning Item"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Cleaning Item",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Cleaning Item"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>

                  <DepartmentDropdown />
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditCleaningTraceabilityItem;
